import { MonitorsRouter } from 'areas/assets/monitors/bundleDescription';
import { MonitorType } from 'areas/assets/monitors/monitorType';
import { RouteEntry } from 'framework/routing/routeEntry';
import { ServiceMonitorPageProps } from 'areas/monitors/service-monitor/service-monitor-page/types';

export function getRoute(): RouteEntry<ServiceMonitorPageProps> {
	return {
		url: MonitorsRouter.list(MonitorType.WindowsServices) + '/:id',
		getModuleImport: async () => await import('areas/monitors/service-monitor/service-monitor-page/serviceMonitorPage'),
		routeId: 'monitor_windows-service',
	};
}
